export enum PromiseType {	
	External = 0,
	Internal = 10,
	Sales = 20,
}